import { render } from "./ConditionalRenderer.vue?vue&type=template&id=4b772aef&ts=true"
import script from "./ConditionalRenderer.vue?vue&type=script&lang=ts"
export * from "./ConditionalRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__